import { create } from 'zustand';

export type ChurchSwitchingMode = 'switch' | 'join';

interface ChurchSwitchingState {
  active: boolean;
  mode: ChurchSwitchingMode;
  churchName: string | null;
  start: (input: { mode?: ChurchSwitchingMode; churchName?: string | null }) => void;
  finish: () => void;
}

export const useChurchSwitchingStore = create<ChurchSwitchingState>((set) => ({
  active: false,
  mode: 'switch',
  churchName: null,
  start: ({ mode = 'switch', churchName = null }) =>
    set({ active: true, mode, churchName: churchName?.trim() || null }),
  finish: () => set({ active: false, mode: 'switch', churchName: null }),
}));
